import React, { useContext, createContext, useState, useMemo } from "react";
import { ContratoField } from "./ContratoField";

const ContratoFieldsContext = createContext({});

const initialField = { id: 1, value: 0 };

export const ContratoFieldsProvider = ({
  valorAcordo,
  onFieldAdd,
  onFieldRemove
}) => {
  const [fields, setFields] = useState([initialField]);

  const addField = () => {
    setFields([...fields, { id: fields.length + 1, value: 0 }]);

    onFieldAdd();
  };

  const removeField = fieldIndex => {
    setFields([...fields.filter(field => field.id !== fieldIndex)]);

    onFieldRemove();
  };

  const updateFieldValue = (id, value) =>
    setFields(
      fields.map(field => (field.id === id ? { ...field, value } : field))
    );

  const valorTotalContratos = useMemo(() => {
    return fields
      .map(field => field.value)
      .reduce((previus, current) => previus + current, 0);
  }, [fields]);

  return (
    <ContratoFieldsContext.Provider
      value={{
        fields,
        addField,
        removeField,
        valorTotalContratos,
        updateFieldValue
      }}
    >
      {fields.map(field => (
        <ContratoField
          key={`${field.id}`}
          fieldId={field.id}
          valorAcordo={valorAcordo}
        />
      ))}
    </ContratoFieldsContext.Provider>
  );
};

export const useContratoFields = () => useContext(ContratoFieldsContext);



// WEBPACK FOOTER //
// ./src/pages/Acordo/Create/Formulario/use-contrato-fields.jsx